class DomainManager {
  targetEnv = '';

  constructor(targetEnv: string) {
    this.targetEnv = targetEnv;
  }

  getAuthServiceDomain() {
    if (this.targetEnv === 'production') {
      return 'https://auth.myrealtrip.com';
    }

    return `https://auth.${this.targetEnv}-myrealtrip.com`;
  }

  getMemberServiceDomain() {
    if (this.targetEnv === 'production') {
      return 'https://member.myrealtrip.com';
    }

    return `https://member.${this.targetEnv}-myrealtrip.com`;
  }

  getTravelerServiceDomain() {
    if (this.targetEnv === 'production') {
      return 'https://www.myrealtrip.com';
    }

    return `https://www.${this.targetEnv}-myrealtrip.com`;
  }

  getLegacyApiDomain() {
    if (this.targetEnv === 'production') {
      return 'https://api.myrealtrip.com';
    }

    return `https://api.${this.targetEnv}-myrealtrip.com`;
  }

  getApiDomain() {
    if (this.targetEnv === 'production') {
      return 'https://api3.myrealtrip.com';
    }

    return `https://api3.${this.targetEnv}-myrealtrip.com`;
  }

  getPartnerDomain() {
    if (this.targetEnv === 'production') {
      return 'https://partner.myrealtrip.com';
    }

    return `https://partner.${this.targetEnv}-myrealtrip.com`;
  }

  getSupportDomain() {
    if (this.targetEnv === 'production') {
      return 'https://support.myrealtrip.com';
    }

    return `https://support.${this.targetEnv}-myrealtrip.com`;
  }
}

export default DomainManager;
